// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import "babel-polyfill";
import {resize} from '../static/js/rem'
import {toRouter} from '../static/js/toRouter'
import '../static/css/reset.css'
import 'video.js/dist/video-js.css';
import 'swiper/dist/css/swiper.css'
import '../static/css/style.css'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import jquery from 'jquery'
import Swiper from 'swiper'
import Page from 'v-page'
Vue.use(Page)
window.jQuery = window.jquery = window.$ = jquery
window.Swiper = Swiper

Vue.prototype.$http=axios;
Vue.config.productionTip = false
Vue.prototype.toRouter=toRouter;
Vue.prototype.toRouter();

Vue.prototype.resize=resize;
Vue.prototype.resize();
$(window).resize(function(){
  Vue.prototype.resize();
});

// 过滤返回的html字符串
Vue.prototype.removeHtmlStyle = function (html) {
  var rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/
  var newHtml = ''
  if (html) {
    newHtml = html.replace(rel, '')
  }
  return newHtml
}
NProgress.configure({
  easing: 'ease',  
  speed: 500,   
  showSpinner: false,  
  trickleSpeed: 200,  
  minimum: 0.3
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
  document.title = '轻松调频 CRI EZFM，We are the difference';
})

router.afterEach(() => {
  NProgress.done()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js